import { render, staticRenderFns } from "./PresentationCard.vue?vue&type=template&id=a1bb5a5e&"
import script from "./PresentationCard.vue?vue&type=script&lang=js&"
export * from "./PresentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports